















import {Component, Vue, Watch} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import {payloadMakeLogin} from '@/store/modules/authentication/actions';
import {AUTH_WITH_ERROR, IS_AUTH_WITH_ERROR, IS_MAKING_LOGIN, MAKE_LOGIN} from '@/store/modules/authentication/types';

@Component
export default class LoginPopup extends Vue {
  public email: string = '';
  public password: string = '';

  @Getter(IS_MAKING_LOGIN)
  public isMakingLogin: boolean;

  @Getter(IS_AUTH_WITH_ERROR)
  public error: boolean;

  @Action(MAKE_LOGIN)
  private requestLogin: (obj: payloadMakeLogin) => void;

  @Action(AUTH_WITH_ERROR)
  private changeStatusError: (withError: boolean) => void;


  requestData () {
    this.changeStatusError(false);

    const payload: payloadMakeLogin = {
        email: this.email,
        password: this.password
    };
    this.requestLogin(payload);
  }
}
